import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef } from 'react';
import { LoginWithAppleHandler, LoginWithGoogleHandler, LoginWithFacebookHandler } from './clients';
const ProviderContext = createContext({});
export const AccountServiceProvider = ({ children, configs }) => {
    const providers = useRef(new Map([
        ['google', new LoginWithGoogleHandler(configs.googleAppId, configs.ssoServer)],
        ['facebook', new LoginWithFacebookHandler(configs.facebookAppId, configs.ssoServer)],
        ['apple', new LoginWithAppleHandler(configs.appleAppId, configs.ssoServer)],
    ]));
    return (_jsx(ProviderContext.Provider, { value: { providers: providers.current, configs }, children: children }, void 0));
};
export const useLoginProvider = () => {
    const { providers } = useContext(ProviderContext);
    return {
        facebook: providers.get('facebook'),
        google: providers.get('google'),
        apple: providers.get('apple'),
    };
};
export const useConfigs = () => {
    const { configs } = useContext(ProviderContext);
    return configs;
};
//# sourceMappingURL=provider.js.map